import * as React from 'react';
import { useRouteError } from 'react-router-dom';
import { isRouteErrorResponse } from '@remix-run/router'
import style from './AppErrorBoundary.scss';

type Props = {};

const AppErrorBoundary: React.FC<Props> = (props) => {
  const error = useRouteError();

  let message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : JSON.stringify(error);
  let stack = error instanceof Error ? error.stack : null;

  return (
    <div className={style.wrapper}>
      <div className={style.container}>
        <h2>{message}</h2>
        {stack ? <pre>{stack}</pre> : null}
      </div>
    </div>
  );
}

export default React.memo(AppErrorBoundary);
